<script>
    import MediaInput from '../../common/Media/MediaInput.svelte';
    import Marker from '../../common/Media/Marker.svelte';
    import Modal from '../../Modal.svelte';
    import ConfirmationModal from '../../ConfirmationModal.svelte';
    import {targetItem, elementVersionEntity} from './elementMediaStore.js';
    import {sgettext} from '../../../i18n.js';
    import {submit} from '../../../utils.js';

    export let id = '';
    export let key = '';
    export let onRemove = () => {
    };
    export let onShowMarker = () => {
    };
    export let onRemoveMarkup = () => {
    };
    export let media = null;
    export let width = '160px';
    export let height = '90px';
    export let onChange = () => {
    };
    export let allowRemove = false;
    export let useMarker = true;
    export let useMediaLibrary = true;
    export let mediaLibraryId = '';
    export let row = null;
    export let entity = null;
    export let showActionBar = true;
    export let dropAreaStyle = '';

    let showMarker = false;
    let showMediaLibrary = false;
    let elementMediaSelectionModalId = 'elementMediaSelectionModal';
    let mediaInput;

    function onShowMediaLibraryClick() {
        if (useMediaLibrary) {
            targetItem.set(row);
            elementVersionEntity.set(entity);
            if (mediaLibraryId) {
                jQuery(`#${mediaLibraryId}`).modal('show');
            }
        } else {
            mediaInput.showFileBrowser();
        }
    }

    function onRemoveClick(event) {
        onRemove(media);
    }

    function onShowMarkerClick() {
        if (media && media.id) {
            targetItem.set(row);
            elementVersionEntity.set(entity);
            onShowMarker(media.id, row.id);
        }
    }

    function onRemoveMarkupClick() {
        if (media && media.id) {
            targetItem.set(row);
            elementVersionEntity.set(entity);
            onRemoveMarkup(media.id, row.id);
        }
    }

    function handleElementMediaSelectionCancel() {

    }
</script>

<div class="element-media-input my-element-media-input">
  <MediaInput
    bind:this={mediaInput}
    {id}
    {key}
    bind:media
    {width}
    {height}
    {onChange}
    showLibrary={onShowMediaLibraryClick}
    {dropAreaStyle}
  />

  {#if media && Object.keys(media).length && showActionBar}
    <div class="actions-bar">
      {#if useMarker && media.type === 'IMAGE' && row && (row.id || row.evId)}
        <i
          class="fas fa5-marker"
          title={sgettext('$$MARKER$$')}
          on:click={onShowMarkerClick}
        />

        {#if media.markup_location}
          <i
            class="fas fa5-times-circle"
            title={sgettext('$$REMOVE_MARKUP_1$$')}
            on:click={onRemoveMarkupClick}
          />
        {/if}
      {/if}
      <i
        class="fas fa5-photo-video"
        title={sgettext('$$BROWSE_MEDIA$$')}
        on:click={onShowMediaLibraryClick}
      />
      {#if allowRemove}
        <i
          class="fas fa5-trash-alt"
          title={sgettext('$$REMOVE$$')}
          on:click={onRemoveClick}
        />
      {/if}
      {#if showMarker}
        <Marker />
      {/if}
    </div>
  {/if}
</div>

<style>
  .element-media-input {
    position: relative;
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
  }

  .actions-bar {
    display: flex;
    flex-direction: column;
    padding: 6px;
    height: 100%;
    text-align: center;
  }

  .actions-bar:hover .fas {
    opacity: 1;
  }

  .actions-bar .fas {
    margin-bottom: 16px;
    opacity: 0.5;
    cursor: pointer;
  }

  .actions-bar .fas:hover {
    color: #dd5900;
  }
</style>
